import React from 'react';

class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldBeExpanded: false,
    };
  }

  handleFocus = (e) => {
    this.setState({ shouldBeExpanded: true });
  };

  handleBlur = (e) => {
    this.setState({ shouldBeExpanded: !!e.target.value.trim() });
  };

  render() {
    const { className, placeholder, name, ...others } = this.props;
    const { shouldBeExpanded } = this.state;
    const isDisabled = !!this.props.disabled;

    return (
      <React.Fragment>
        <span className="c-input c-input--nao u-margin-bottom-small">
          <input
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            type="text"
            id={name}
            name={name}
            className={`c-input c-input-nao__field c-input__field--nao c-input--transparent ${className} ${
              shouldBeExpanded || isDisabled || others.value
                ? 'c-input--filled'
                : ''
            }`}
            {...others}
          />
          <label className="c-input__label c-input__label--nao" htmlFor={name}>
            <span className="c-input__label-content c-input__label-content--nao">
              {placeholder}
            </span>
          </label>
          <svg
            className="graphic graphic--nao"
            width="300%"
            height="100%"
            viewBox="0 0 1200 60"
            preserveAspectRatio="none"
          >
            <path d="M0,56.5c0,0,298.666,0,399.333,0C448.336,56.5,513.994,46,597,46c77.327,0,135,10.5,200.999,10.5c95.996,0,402.001,0,402.001,0"/>
          </svg>
        </span>
      </React.Fragment>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/common/Input.js